import type { Locale } from "../localization/constants";
import {
  adminUiTranslations,
  type AdminUiTranslations,
} from "./adminUiTranslations";
import { normalizeFireCMSLocale } from "./adminLocales";

export type AdminTranslateFn = (
  key: string,
  vars?: Record<string, string | number>
) => string;

function getNestedValue(
  obj: AdminUiTranslations,
  key: string
): string | undefined {
  const parts = key.split(".");
  let current: unknown = obj;
  for (const part of parts) {
    if (current === null || typeof current !== "object") {
      return undefined;
    }
    current = (current as Record<string, unknown>)[part];
  }
  return typeof current === "string" ? current : undefined;
}

function interpolate(
  template: string,
  vars?: Record<string, string | number>
): string {
  if (!vars) {
    return template;
  }
  return Object.entries(vars).reduce(
    (text, [name, value]) =>
      text.replaceAll(`{{${name}}}`, String(value)),
    template
  );
}

export function getAdminT(localeCode?: string): AdminTranslateFn {
  const locale = normalizeFireCMSLocale(localeCode) as Locale;
  const bundle = adminUiTranslations[locale];
  const fallback = adminUiTranslations.en;

  return (key: string, vars?: Record<string, string | number>) => {
    const template =
      getNestedValue(bundle, key) ??
      getNestedValue(fallback, key) ??
      key;
    return interpolate(template, vars);
  };
}
